import React from 'react';
import styled from 'styled-components';
import { FiX, FiCheck, FiFilter } from 'react-icons/fi';

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  animation: fadeIn 0.3s ease;
  
  @keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
  }
`;

const ModalContent = styled.div`
  background: white;
  border-radius: 16px;
  padding: 30px;
  max-width: 500px;
  width: 90%;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
  animation: slideUp 0.3s ease;
  
  @keyframes slideUp {
    from {
      transform: translateY(50px);
      opacity: 0;
    }
    to {
      transform: translateY(0);
      opacity: 1;
    }
  }
`;

const ModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
`;

const ModalTitle = styled.h3`
  color: #424242;
  font-size: 1.4rem;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 10px;
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  color: #757575;
  cursor: pointer;
  padding: 5px;
  display: flex;
  align-items: center;
  font-size: 1.5rem;
  
  &:hover {
    color: #424242;
  }
`;

const ModalBody = styled.div`
  margin-bottom: 30px;
`;

const Message = styled.p`
  color: #616161;
  font-size: 1rem;
  line-height: 1.6;
  margin-bottom: 20px;
`;

const InfoBox = styled.div`
  background: #e3f2fd;
  border-left: 4px solid #2196f3;
  padding: 15px;
  border-radius: 8px;
  margin: 15px 0;
`;

const InfoText = styled.p`
  color: #1976d2;
  font-size: 0.9rem;
  margin: 0;
  line-height: 1.5;
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 12px;
  justify-content: flex-end;
`;

const Button = styled.button`
  padding: 12px 24px;
  border: none;
  border-radius: 8px;
  font-size: 0.95rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 8px;
  
  ${props => props.$primary ? `
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
    
    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
    }
  ` : `
    background: #f5f5f5;
    color: #616161;
    
    &:hover {
      background: #e0e0e0;
    }
  `}
`;

const RulesModal = ({ isOpen, onClose, onYes, onNo }) => {
  if (!isOpen) return null;

  return (
    <ModalOverlay onClick={onClose}>
      <ModalContent onClick={e => e.stopPropagation()}>
        <ModalHeader>
          <ModalTitle>
            <FiFilter style={{ color: '#667eea' }} />
            Apply Filtering Rules?
          </ModalTitle>
          <CloseButton onClick={onClose}>
            <FiX />
          </CloseButton>
        </ModalHeader>
        
        <ModalBody>
          <Message>
            <strong>AI processing completed successfully!</strong>
          </Message>
          
          <Message>
            Would you like to apply additional filtering rules to your processed data?
          </Message>
          
          <InfoBox>
            <InfoText>
              <strong>💡 Tip:</strong> You can filter by postal codes, cities, countries, or any other criteria using natural language.
              <br /><br />
              <strong>Examples:</strong>
              <br />• "Filter postal codes 020 01"
              <br />• "Show only Berlin addresses"
              <br />• "Country equals Germany"
            </InfoText>
          </InfoBox>
        </ModalBody>
        
        <ButtonGroup>
          <Button onClick={onNo}>
            <FiX />
            No, Download Now
          </Button>
          <Button $primary onClick={onYes}>
            <FiCheck />
            Yes, Apply Rules
          </Button>
        </ButtonGroup>
      </ModalContent>
    </ModalOverlay>
  );
};

export default RulesModal;